import { memo } from "react";

import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";
import type { ForArrayType } from "@/components/features/_model/types/auto-generator-for-view-model";

import type { FormOptionType } from "@/components/ui/form/_types/type";
import { CheckboxGroupField } from "@/components/ui/form/fields/check-box-field/check-box-group";

import type { CheckedState } from "@radix-ui/react-checkbox";

type Props = {
	availableItemIDs: ForArrayType<string[]>;
	rawAvailableItemIDs: string[];
	onSetAvailableItemIDs: (input: CheckedState, item: FormOptionType) => void;
	nameAndIDOptions: FormOptionType[];

	title: string;
	guide?: string;
	description?: string;
	required?: boolean;
};

export const QuestionConnection = memo(
	({
		availableItemIDs,
		rawAvailableItemIDs,
		onSetAvailableItemIDs,
		nameAndIDOptions,

		title,
		guide: _guide,
		description,
		required = false,
	}: Props) => {
		const guide = _guide || "";

		return (
			<FeatureIslandCategoryQuestionForMain
				required={required}
				title={title}
				guide={guide}
				hasError={availableItemIDs?.hasError ?? false}
				isEdited={availableItemIDs?.isEdited ?? false}
				inputChildren={
					<>
						{description && <p className="text-sm text-brand">{description}</p>}

						{nameAndIDOptions.length === 0 ? (
							<>選択できるアイテムがありません</>
						) : (
							<CheckboxGroupField
								value={rawAvailableItemIDs}
								options={nameAndIDOptions}
								handleCheckedChange={onSetAvailableItemIDs}
								gridCols={2}
								errorMessage={availableItemIDs?.error}
							/>
						)}
					</>
				}
			/>
		);
	},
);

QuestionConnection.displayName = "QuestionConnection";
